export class EwayBillDialogModel {
    constructor(
        public data: Object
    ) {}
}